/**
 *
 * Address Service Sagas
 *
 */

import isObject from 'lodash/isObject';
import isFunction from 'lodash/isFunction';
import { take, call, put } from 'redux-saga/effects';
import { notAsked, ADDRESS_REQUEST, success, loading, failure } from './index';
import { addressPreviewRequest } from './api';

export function* requestFlow(apexAccountId) {
  yield put(loading(apexAccountId));

  try {
    const result = yield call(addressPreviewRequest, apexAccountId);
    yield put(success(result));
  } catch (err) {
    let errorBody = err;
    if (isObject(err.response)) {
      if (isFunction(err.response.json)) {
        errorBody = yield err.response.json();
      }
      errorBody.status = err.response.status;
    } else {
      errorBody = errorBody.toString();
    }
    // The .json() method turns the response body into a promise.
    // Set status to FAILURE and pass along the error
    yield put(failure(errorBody));
  }
}

export function* addressServiceFlow() {
  // Set the initial status
  yield put(notAsked());

  while (true) {
    // Watch for SEARCH_REQUEST to be dispatched
    const { apexAccountId } = yield take(ADDRESS_REQUEST);

    // Make the request
    yield call(requestFlow, apexAccountId);
  }
}

export default [addressServiceFlow()];



// WEBPACK FOOTER //
// ./src/services/addressPreview/sagas.js